// NEW FILE: src/types/sessionContext.ts

export type SessionContext = {
    connectionId: string;
    layout: {
        name: string;
        workflow: {
            currentStep: number;
            steps: Record<
                string,
                {
                    screen: string;
                    fields: Record<string, any>;
                    chat: {
                        history: { sender: "user" | "assistant"; text: string }[];
                        latestTranscript: string;
                        interrupts: number;
                    };
                }
            >;
        };
        assistant: {
            // Original properties
            tab: "chat" | "call";
            language: string;
            lastPrompt: string;
            lastToolUsed: string;

            // Add new properties needed in RealtimeContext
            name?: string;
            avatarUrl?: string;
            welcomeMessage?: string;
        };
    };
    metadata: {
        createdAt: string;
        device: string;
        version: string;
    };
};

export const createDefaultSessionContext = (connectionId: string): SessionContext => ({
    connectionId,
    layout: {
        name: "baseDemo",
        workflow: {
            currentStep: 1,
            steps: {
                "1": { screen: "StepOneForm", fields: {}, chat: { history: [], latestTranscript: "", interrupts: 0 } },
                "2": { screen: "StepTwoForm", fields: {}, chat: { history: [], latestTranscript: "", interrupts: 0 } },
                "3": { screen: "StepThreeForm", fields: {}, chat: { history: [], latestTranscript: "", interrupts: 0 } },
                "4": { screen: "StepFourForm", fields: {}, chat: { history: [], latestTranscript: "", interrupts: 0 } }
            }
        },
        assistant: {
            tab: "chat",
            language: "en",
            lastPrompt: "base_1",
            lastToolUsed: ""
        }
    },
    metadata: {
        createdAt: new Date().toISOString(),
        device: "mobile",
        version: "1.0.0"
    }
});
